import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Shield",
	width: 24,
	height: 25,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9997 21.959C11.9997 21.959 19.3237 19.7416 19.3237 13.6284C19.3237 7.5152 19.5897 7.04136 19.0017 6.44882C18.4127 5.8553 12.9607 3.95898 11.9997 3.95898C11.0397 3.95898 5.58669 5.86017 4.99769 6.44882C4.40969 7.03649 4.67669 7.51422 4.67669 13.6284C4.67669 19.7426 11.9997 21.959 11.9997 21.959Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShield1Line;
